// src/components/strumenti/ConversioneVelocitaDati.js
import React, { useState } from "react";
import { RefreshCw } from "lucide-react";
import { leggiNumero } from "../../utils/numeriStrumenti";

export default function ConversioneVelocitaDati() {
  const [valore, setValore] = useState("");
  const [unita, setUnita] = useState("mbps");

  const v = leggiNumero(valore)||0;
  // Tutto convertito in bit/s come base comune
  const inBps = unita==="kbps" ? v*1000 : unita==="mbps" ? v*1000000 : unita==="gbps" ? v*1000000000
    : unita==="kBs" ? v*8000 : unita==="MBs" ? v*8000000 : v*8000000000; // GBs

  const risultati = [
    { label:"kbps", val:inBps/1000 },
    { label:"Mbps", val:inBps/1000000 },
    { label:"Gbps", val:inBps/1000000000 },
    { label:"kB/s", val:inBps/8000 },
    { label:"MB/s", val:inBps/8000000 },
    { label:"GB/s", val:inBps/8000000000 },
  ];
  const mappaUnita = { kbps:"kbps", mbps:"Mbps", gbps:"Gbps", kBs:"kB/s", MBs:"MB/s", GBs:"GB/s" };

  return (
    <div>
      <div style={{ display:"flex", gap:8, marginBottom:16 }}>
        <input value={valore} onChange={e=>setValore(e.target.value)} placeholder="Valore"
          style={{ flex:1, padding:"10px 12px", border:"1px solid #e5e7eb", borderRadius:8, fontSize:14, fontFamily:"'Inter',sans-serif", outline:"none" }}/>
        <select value={unita} onChange={e=>setUnita(e.target.value)}
          style={{ padding:"10px 12px", border:"1px solid #e5e7eb", borderRadius:8, fontSize:14, fontFamily:"'Inter',sans-serif", outline:"none" }}>
          <option value="kbps">kbps</option>
          <option value="mbps">Mbps</option>
          <option value="gbps">Gbps</option>
          <option value="kBs">kB/s</option>
          <option value="MBs">MB/s</option>
          <option value="GBs">GB/s</option>
        </select>
      </div>
      <div style={{ display:"grid", gridTemplateColumns:"repeat(3,1fr)", gap:10 }}>
        {risultati.map(r => (
          <div key={r.label} style={{ background: mappaUnita[unita]===r.label ? "#eff6ff" : "#f9fafb", border:`1px solid ${mappaUnita[unita]===r.label?"#bfdbfe":"#e5e7eb"}`, borderRadius:10, padding:"12px 10px", textAlign:"center" }}>
            <div style={{ fontSize:11, color:"#9ca3af", fontWeight:600, marginBottom:4 }}>{r.label}</div>
            <div style={{ fontSize:15, fontWeight:800, color:"#2563eb" }}>{r.val.toLocaleString("it-IT",{maximumFractionDigits:3})}</div>
          </div>
        ))}
      </div>
      <button onClick={()=>{setValore("");setUnita("mbps");}}
        style={{ marginTop:16, display:"flex", alignItems:"center", gap:6, fontSize:12, color:"#9ca3af", background:"none", border:"none", cursor:"pointer" }}>
        <RefreshCw size={12}/> Azzera
      </button>
    </div>
  );
}
